import { render, staticRenderFns } from "./com_changepassword.vue?vue&type=template&id=49369dd7"
import script from "./com_changepassword.vue?vue&type=script&lang=js"
export * from "./com_changepassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports